import { PropsWithChildren } from "react";

export type CentralHeaderProps = {
    DarkText: string,
    SecondaryText: string,
}

export function CentralHeader(props: PropsWithChildren<CentralHeaderProps>) {
    return (
        <>
            <div className="d-flex align-items-center flex-column  justify-content-center no-highlight">
                <h2 aria-label={`Section header - ${props.DarkText} ${props.SecondaryText}`}><span className="text-dark me-2" aria-hidden>{props.DarkText}</span><span className="text-secondary" aria-hidden>{props.SecondaryText}</span></h2>
                <div className="flex-grow">
                    <hr className="ShortBlock" />
                </div>
            </div>
        </>
    );
}